
export default {
  props: ["isShow", "updataShow", "headerData"],
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if (this.isShow) return;
      if (this.$el && !this.$el.contains(event.target)) {
        this.$emit("updataShow");
      }
    },
  },
};
